export const NAVIGATION_ROUTES = {
    app: {
        base: '',
        dicovery: 'discoveryChat',
        personalView: 'personalView',
        allMotivationsView: 'allMotivationsView',
        teamView: 'teamView',
        teamActiveMoovsView: 'activeMoovs',
        userProfileView:'userProfile',
        adminView:'admin',
        resellerView: 'reseller',
        firstTimeLogin:'firstTime',
        detailsView:'details',
        detailsView_enetity:'details/:entity',
        state:'state',
        chatView: 'chat',
        pulsecheckView: 'pulse',
        processView: 'process', 
        info: 'info'
    },
    home: '',
    notFound: '404',
    sessionExpired: 'session-expired',
    noPermission: 'no-permission',
    login: 'login',
    unsubscribe: 'unsubscribe',
    tokenLogin: 'discover',
    register: 'register',
    userResponse:'userResponse',
    fallback: '**'
}

export enum ExternalRedirectOriginEnum{
    DEFAULT = 0,
    ENGAGEMENT = 1,
    PULSE_CHECK = 2,
    USER_TEAM_VIEW = 3
}